var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7775 0.5H4.67357C4.27018 0.5 3.94279 0.834328 3.94279 1.24627V4.52637H0.730778C0.327388 4.52637 0 4.8607 0 5.27264V19.7537C0 20.1657 0.327388 20.5 0.730778 20.5H11.8347C12.2381 20.5 12.5655 20.1657 12.5655 19.7537V16.4736H15.7775C16.1809 16.4736 16.5083 16.1393 16.5083 15.7274V1.24627C16.5083 0.834328 16.1809 0.5 15.7775 0.5ZM11.1039 19.0075H1.46156V6.01891H11.1039V19.0075ZM15.0467 14.9811H12.5655V5.27264C12.5655 4.8607 12.2381 4.52637 11.8347 4.52637H5.40434V1.99254H15.0467V14.9811Z",
    fill: "#B0B7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.89f195a150360f23cbadef0ad2d5fc52.svg";
export { ForwardRef as ReactComponent };